import { render } from "./SalesWonReport.vue?vue&type=template&id=08a30bbc&scoped=true"
import script from "./SalesWonReport.vue?vue&type=script&lang=js"
export * from "./SalesWonReport.vue?vue&type=script&lang=js"

import "./SalesWonReport.vue?vue&type=style&index=0&id=08a30bbc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a30bbc"]])

export default __exports__